export enum UserSettingOption {
  Notset = 'Notset',
  Active = 'Active',
  Inactive = 'Inactive'
}
